import { lazy } from 'react';
import { retry } from '@/utils/helpers/common';

export const OdooSyncPage = lazy(
  () =>
    retry(
      () => import('@pages/settings/integrations/odoo-sync')
    ) as Promise<typeof import('@pages/settings/integrations/odoo-sync')>
);

export const LlmConfigPage = lazy(
  () =>
    retry(
      () => import('@pages/settings/integrations/llm-config')
    ) as Promise<typeof import('@pages/settings/integrations/llm-config')>
);
